import Splide from '@splidejs/splide';

$ = jQuery;

const setGallery = function () {
  if (!$('.js-gallery').length) {
    return;
  }

  const splide = new Splide('.js-gallery', {
    type: 'loop',
    rewind: true,
    autoWidth: true,
    gap: '10px',
    autoplay: true,
    interval: 2000,
    speed: 1000,
    focus: 'center',
    arrows: true,
    pagination: false,
  });

  splide.mount();
};

const setReference = function () {
  if (!$('.js-reference').length) {
    return;
  }

  const splide = new Splide('.js-reference', {
    type: 'fade',
    rewind: true,
    autoplay: true,
    interval: 5000,
    speed: 1000,
    arrows: true,
    pagination: false,
    autoHeight: true,
  });

  splide.mount();
};

jQuery(document).ready(function ($) {
  setGallery();
  setReference();

  $('[href^=#]').click(function (e) {
    e.preventDefault();
    let id = $(this).attr('href');
    let element = $(id);
    if (element.length) {
      $('html,body').animate({scrollTop: element.offset().top - 60}, 1000);
    }
  });

  $('.js-menu-button-open, .js-menu-button-close').click(function (e) {
    e.preventDefault();

    $('.js-menu-wrapper').toggleClass('open');
    $('.js-header').toggleClass('mobile-menu-open');
  });

  $('.js-toggle-faq').click(function (e) {
    e.preventDefault();
    $(this).parents('.js-faq-item').toggleClass('open');
  });
});